const { CALCULATOR } = require('../config')
const { calculateValues } = require('./calculate-values')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} country
 * @param {number} amount
 * @param {number} duration
 * @returns {*}
 */
function calculate ({ country, amount = undefined, duration = undefined } = {}) {
  if (!country) return
  const calculator = CALCULATOR[country?.toUpperCase()]

  if (!amount || !duration) {
    return calculator.DEFAULT_VALUES
  }

  return calculateValues({
    amount,
    duration,
    interests: calculator.INTERESTS,
    baseInterest: calculator.INTEREST
  })
}

module.exports = { calculate }
